const ArrowIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" fill="none" viewBox="0 0 15 14">
  <path fill="#C11B20" d="M7 0a1 1 0 0 1 .707 1.707L3.414 6H14a1 1 0 0 1 0 2H3.414l4.293 4.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6A.997.997 0 0 1 7 0Z" />
</svg>



export default ArrowIcon;
